import { Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { VazeciProcenatZarade } from './vazeci-procenat-zarade';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-vazeci-procenat-zarade-update',
  templateUrl: './vazeci-procenat-zarade-update.component.html'
})
export class VazeciProcenatZaradeUpdateComponent extends BaseUpdateComponent<VazeciProcenatZarade> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.IDProcessed
    .subscribe((value) => {
        if (value && this.Item.ID == -1) {
            let dateNow = new Date();
            let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
            this.baseFormGroup.patchValue({ DatumOd: date });
            this.baseFormGroup.get('DatumOd').updateValueAndValidity();
        }
    })
     this.addValidatorToFc("DatumOd", Validators.required, 'required', 'VAZECIPROCENAT.DATUM.VALIDATION.REQUIRED');
     this.addValidatorToFc("ProcenatPlatniPromet", Validators.required, 'required', 'VAZECIPROCENAT.PROCENATPLATNIPROMET.VALIDATION.REQUIRED');
     this.addValidatorToFc("ProcenatWesternUnion", Validators.required, 'required', 'VAZECIPROCENAT.PROCENATWESTERNUNION.VALIDATION.REQUIRED');
  }

  

}
